import { ImpressionBatchPayload, PageViewPayload } from '@/js/pages/helpers/tracking-script/types';

export const pv = async (payload: PageViewPayload): Promise<void> => {
    const trackerBaseUrl = import.meta.env.VITE_VULPR_BASE_URL;

    if (!trackerBaseUrl) {
        return;
    }

    const api = `${trackerBaseUrl}/api/v1/tr/pv`;

    await fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors',
    });
};

/**
 * Sends a batch of impression events to Vulpr.
 *
 * When `useBeacon` is true (e.g. on pagehide) navigator.sendBeacon is used so the
 * request survives the page being unloaded. Returns whether the batch was dispatched.
 */
export const impression = (payload: ImpressionBatchPayload, useBeacon = false): boolean => {
    const trackerBaseUrl = import.meta.env.VITE_VULPR_BASE_URL;

    if (!trackerBaseUrl) {
        return false;
    }

    const api = `${trackerBaseUrl}/api/v1/tr/impression`;
    const body = JSON.stringify(payload);

    if (useBeacon && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        return navigator.sendBeacon(api, new Blob([body], { type: 'application/json' }));
    }

    fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
        credentials: 'omit',
        mode: 'cors',
    }).catch(() => {
        /* swallow network errors; impressions are best-effort */
    });

    return true;
};
